import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type PropertyQueryVariables = Types.Exact<{
    propertyId: Types.Scalars['String'];
}>;

export type PropertyQuery = { __typename?: 'Query' } & {
    property?: Types.Maybe<
        { __typename?: 'Property' } & Pick<
            Types.Property,
            'uprn' | 'propertyId'
        >
    >;
};

export const PropertyDocument = gql`
    query property($propertyId: String!) {
        property(id: $propertyId) {
            uprn
            propertyId
        }
    }
`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertyQuery(
    baseOptions: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(
        PropertyDocument,
        options
    );
}
export function usePropertyLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PropertyQuery,
        PropertyQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(
        PropertyDocument,
        options
    );
}
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<
    typeof usePropertyLazyQuery
>;
export type PropertyQueryResult = Apollo.QueryResult<
    PropertyQuery,
    PropertyQueryVariables
>;
